export default "__VITE_ASSET__B$J9VKnQ__"